module.exports = {
  deepFind(obj, keys) {
    let value = Object.assign({}, obj);
    keys = keys.split('.');
    keys.forEach(k => {
      if(k in value) {
        value = value[k];
      } else return null;
    });
    return value;
  },

  objectFilter(obj, keys) {
    let filtered = {};
    if(Array.isArray(keys)) {
      keys
        .filter(k => k in obj)
        .forEach(k => filtered[k] = obj[k]);
    } else if(keys instanceof Object && Object.keys(keys).length) {
      Object.entries(keys)
        .filter(([dKey, sKey]) => sKey in obj)
        .forEach(([dKey, sKey]) => filtered[dKey] = obj[sKey]);
    }
    return filtered;
  }
}
